(ns storrito.state.local-storage
  (:require [alandipert.storage-atom :as storage-atom]
            [reagent.core :as reagent]))

;; Concept:
;;
;; Provides an atom `state` that stores its values into the browser's
;; `js/localStorage`. It is cleared during login and logout
;; process. Despite that `state` behaves like an ordinary Clojure
;; atom. Use this atom to store settings which should survive page
;; refreshes and the closing of the Storrito browser tab.
;;
;; Example use case: the calendar should store the selected Instagram
;; accounts, so that the user do not have to repeat the selection
;; process on a panel switch or page refresh.

(def ^:private storage-key
  :storrito.state.local-storage)

(defn- persistent-atom
  "Backs `atom` by `js/localStorage` under the key `k`.

   Returns the plain `atom` when the browser refuses the storage:
   reading `window.localStorage` throws a SecurityError when storage
   access is denied (enterprise policy, blocked site data, third-party
   storage partitioning), or it is `null` in some private modes. These
   `def`s run while the bundle loads, so the uncaught error killed the
   whole app instead of just the persistence. Without storage the
   settings only last for the page load. Sentry: STORRITO-V2-JR."
  [atom k]
  (try
    (storage-atom/local-storage atom k)
    (catch :default e
      (js/console.warn "localStorage is not available, settings will not survive a reload:" e)
      atom)))

(def state
  (persistent-atom (atom {})
                   storage-key))

(def state*
  (persistent-atom (reagent/atom {})
                   :storrito.local-storage))

(defn clear!
  []
  (reset! state {}))
